const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478 465.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.08,197.81a800.86,800.86,0,0,0-38.82-70.48c-21.4-34.69-49.42-67.21-86.09-87.73C258.1-8,160.12,10.64,95.51,65.47S83.67,190.64,71.82,243.4,22.29,294.09,12.6,370.64,112.74,492.71,197.8,473.05,284,418.23,356.09,416.16s115.22-23.8,130.29-104.49c5.3-28.35,5.86-59.17-5.71-86.25C476.75,216.24,472.53,207,468.08,197.81Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.08,197.81a800.86,800.86,0,0,0-38.82-70.48c-21.4-34.69-49.42-67.21-86.09-87.73C258.1-8,160.12,10.64,95.51,65.47S83.67,190.64,71.82,243.4,22.29,294.09,12.6,370.64,112.74,492.71,197.8,473.05,284,418.23,356.09,416.16s115.22-23.8,130.29-104.49c5.3-28.35,5.86-59.17-5.71-86.25C476.75,216.24,472.53,207,468.08,197.81Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.08,
    y1: 438.86,
    x2: 466.91,
    y2: 438.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.16,
    y1: 438.86,
    x2: 446.14,
    y2: 438.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.59,121.92c-1.93-2-5.3-3.86-11.13-4-13.1-.32-9.58,9-13.1,11.19s-4.47-1.28-8,1-1.92,6.71-4.79,7.35-6.72-2.88-10.23-.64-3.52,4.15-5.12,4.15-4.79-1.27-6.71,0-4.15,2.88-4.15,2.88H73.69",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,127.65c-.31-.16-.64-.31-1-.46a8.6,8.6,0,0,0-1.18-3.37",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.08,143.81h42.15s1-2.88-2.56-4.79-5.11-.32-6.39-1.92c-1.14-1.42,2.54-4.87-3.41-8.55",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.19,333.3c-1.94-2-5.3-3.86-11.13-4-13.1-.32-9.59,8.95-13.1,11.18s-4.48-1.28-8,1-1.92,6.71-4.8,7.35-6.71-2.87-10.22-.64-3.52,4.16-5.12,4.16-4.79-1.28-6.71,0-4.15,2.87-4.15,2.87h34.31",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.8,339l-1-.45a8.61,8.61,0,0,0-1.18-3.38",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68,355.18h42.15s1-2.87-2.56-4.79-5.11-.32-6.39-1.92c-1.14-1.42,2.54-4.87-3.42-8.54",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.5,81.83h44.88s1.52-4.59-4.08-7.64-8.16-.51-10.2-3.06,5.61-9.18-9.68-15.8c0,0-1-14.27-21.92-14.78-9-.22-13.1,2.4-15.27,5.75",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.81,
    y1: 69.48,
    x2: 160.28,
    y2: 69.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.51,53.34c-.64,2.17-1.33,4-2.9,5-5.61,3.56-7.14-2-12.74,1.52s-3.06,10.71-7.65,11.73-10.7-4.59-16.31-1-5.61,6.62-8.15,6.62-7.65-2-10.71,0-6.62,4.59-6.62,4.59h57.31",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Grass--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "466.36 438.7 466.36 431.38 460.27 427.64 453.89 431.57 447.5 427.64 441.12 431.57 434.74 427.64 428.36 431.57 421.98 427.64 415.59 431.57 409.21 427.64 402.82 431.57 396.44 427.64 390.06 431.57 383.67 427.64 377.29 431.57 370.9 427.64 364.52 431.57 358.14 427.64 351.75 431.57 345.37 427.64 338.98 431.57 332.6 427.64 326.21 431.57 319.83 427.64 313.45 431.57 307.06 427.64 300.67 431.57 294.29 427.64 287.9 431.57 281.52 427.64 275.13 431.57 268.75 427.64 262.36 431.57 255.98 427.64 249.59 431.57 243.21 427.64 236.82 431.57 230.44 427.64 224.05 431.57 217.66 427.64 211.28 431.57 204.9 427.64 198.51 431.57 192.13 427.64 185.74 431.57 179.36 427.64 172.98 431.57 166.59 427.64 160.21 431.57 153.82 427.64 147.44 431.57 141.05 427.64 134.66 431.57 128.28 427.64 121.89 431.57 115.51 427.64 109.12 431.57 102.73 427.64 96.34 431.57 89.95 427.64 83.56 431.57 77.17 427.64 70.79 431.57 64.4 427.64 58.02 431.57 51.63 427.64 45.24 431.57 38.85 427.64 32.45 431.57 26.07 427.64 20.73 430.92 20.73 438.7 466.36 438.7",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.74,317.3s33.65,3.33,50.7,24.18c0,0,18-24.16,50.37-23.66a65.39,65.39,0,1,0-101.08-.47Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74,317.3s33.65,3.33,50.7,24.18c0,0,18-24.16,50.37-23.66a65.39,65.39,0,1,0-101.08-.47Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74,317.3s33.65,3.33,50.7,24.18c0,0,18-24.16,50.37-23.66a65.39,65.39,0,1,0-101.08-.47Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.47 439.16 72.33 202.95 71.54 439.16 75.47 439.16",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,335.13s11.36-20.45,31.8-26.69c0,0-21.58,5.11-32.37,22.71Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.79,277.76s12.6-21,33-27.25c0,0-22.25,6.41-33,24Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,307.62s12.16-21.9,32.6-28.15c0,0-22.1,6.13-32.89,23.74Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.35,292s-11-20.45-30.69-26.69c0,0,20.82,5.11,31.23,22.71Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.35,320.36s-11-20.44-30.69-26.69c0,0,20.82,5.11,31.23,22.72Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67,317.3s33.64,3.33,50.69,24.18c0,0,18-24.16,50.37-23.66a65.4,65.4,0,1,0-101.07-.47Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67,317.3s33.64,3.33,50.69,24.18c0,0,18-24.16,50.37-23.66a65.4,65.4,0,1,0-101.07-.47Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.39 439.16 400.25 202.95 399.46 439.16 403.39 439.16",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,335.13s11.36-20.45,31.8-26.69c0,0-21.58,5.11-32.37,22.71Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.71,277.76s12.6-21,33-27.25c0,0-22.25,6.41-33,24Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.16,307.62s12.15-21.9,32.59-28.15c0,0-22.1,6.13-32.89,23.74Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27,292s-11-20.45-30.69-26.69c0,0,20.83,5.11,31.24,22.71Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27,320.36s-11-20.44-30.69-26.69c0,0,20.83,5.11,31.24,22.72Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.06,200.23s57.14,5.66,86.11,41.08c0,0,30.6-41,85.56-40.2A111.08,111.08,0,1,0,286,200.33Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.06,200.23s57.14,5.66,86.11,41.08c0,0,30.6-41,85.56-40.2A111.08,111.08,0,1,0,286,200.33Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.93 439.16 358.28 14.63 356.86 439.16 363.93 439.16",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.17,230.51s19.29-34.72,54-45.33c0,0-36.66,8.68-55,38.58Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.07,133.07s21.39-35.67,56.12-46.28c0,0-37.8,10.88-56.12,40.78Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.82,183.79s20.64-37.19,55.37-47.8c0,0-37.55,10.4-55.87,40.31Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.31,157.21s-18.62-34.73-52.12-45.34c0,0,35.37,8.68,53.05,38.58Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.31,205.44s-18.62-34.73-52.12-45.34c0,0,35.37,8.68,53.05,38.58Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.2,406.87a16.43,16.43,0,0,0,4.76.53s-.73-2.21-.79-2.35c-.74-1.54-3.08-4.1-5-3.84a2.27,2.27,0,0,0-1.82,2.85A4.73,4.73,0,0,0,357.2,406.87Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.37,416.64a15.82,15.82,0,0,0,4.68-.73,40.88,40.88,0,0,0,1.82,5c.42,1,.86,1.91,1.32,2.86l-.56-.81c-1.12-1.29-4.06-3.14-5.82-2.39a2.27,2.27,0,0,0-1,3.23,4.73,4.73,0,0,0,3.48,2,14.75,14.75,0,0,0,4.55-.7l.54,1.09c.87,1.74,1.75,3.47,2.56,5.19.29.61.54,1.21.81,1.82l-.49-.7c-1.13-1.3-4.06-3.14-5.83-2.39a2.28,2.28,0,0,0-1,3.23,4.75,4.75,0,0,0,3.49,2,14.65,14.65,0,0,0,4.43-.66c.25.63.5,1.26.71,1.88.13.43.29.83.41,1.27l.35,1.28c.2.82.41,1.66.58,2.47.12.56.23,1.09.34,1.63-.28-.6-.84-1.78-.9-1.87-.91-1.46-3.53-3.73-5.4-3.25a2.27,2.27,0,0,0-1.48,3,4.72,4.72,0,0,0,3.15,2.46,15.38,15.38,0,0,0,4.71,0c.18.89.34,1.76.49,2.59.32,1.81.56,3.44.74,4.82h1.26c-.22-1.42-.51-3.12-.88-5-.18-.91-.39-1.88-.61-2.87a23.26,23.26,0,0,0,2.62-1.23,17.16,17.16,0,0,0,3.83,2.47c-.34.84-.68,1.66-1,2.43-.69,1.6-1.35,3-1.94,4.23h1.36c.51-1.11,1.06-2.38,1.63-3.79.36-.86.71-1.78,1.07-2.73a15.54,15.54,0,0,0,4.7.37,4.75,4.75,0,0,0,3.33-2.23,2.28,2.28,0,0,0-1.26-3.14c-1.82-.61-4.6,1.46-5.62,2.84-.06.08-.61,1-.95,1.65.14-.39.29-.77.43-1.17.29-.79.56-1.59.85-2.45.12-.42.25-.84.38-1.27s.23-.89.34-1.33c.25-1,.45-2.11.63-3.19a15,15,0,0,0,4.46,1,4.74,4.74,0,0,0,3.62-1.7,2.28,2.28,0,0,0-.76-3.3c-1.71-.88-4.78.75-6,2-.08.07-.85,1-1.27,1.58.1-.65.21-1.3.29-2,.24-1.91.42-3.84.61-5.77.05-.59.12-1.18.18-1.77a16,16,0,0,0,4.61,1.08,4.74,4.74,0,0,0,3.62-1.7,2.26,2.26,0,0,0-.76-3.29c-1.71-.89-4.77.74-6,1.95-.09.09-1.2,1.48-1.47,1.85.14-1.3.29-2.59.48-3.86a42.11,42.11,0,0,1,1.11-5.07,16.32,16.32,0,0,0,4.64,1.09,4.74,4.74,0,0,0,3.62-1.7,2.27,2.27,0,0,0-.76-3.3c-1.71-.88-4.77.75-6,2-.1.09-1.29,1.59-1.49,1.88,0-.1.05-.2.08-.3a28.44,28.44,0,0,1,2-4.8c.43-.86.9-1.65,1.37-2.41a15.29,15.29,0,0,0,4.39,1.54,4.79,4.79,0,0,0,3.79-1.28,2.29,2.29,0,0,0-.4-3.37c-1.6-1.06-4.82.22-6.17,1.29l-1.23,1.23.65-1c.8-1.21,1.62-2.27,2.34-3.2.42-.53.8-1,1.17-1.43a15.42,15.42,0,0,0,4.59-.65,4.75,4.75,0,0,0,2.76-2.89,2.27,2.27,0,0,0-1.9-2.8c-1.91-.21-4.18,2.41-4.88,4-.06.13-.76,2.36-.72,2.36h0c-.36.41-.75.86-1.16,1.35-.74.92-1.58,2-2.41,3.16a41.69,41.69,0,0,0-2.51,4,30.28,30.28,0,0,0-2.14,4.82s0,0,0,.06c0-.56,0-2.14,0-2.26-.22-1.7-1.64-4.86-3.54-5.21a2.28,2.28,0,0,0-2.62,2.14,4.75,4.75,0,0,0,1.83,3.56,15.53,15.53,0,0,0,4.31,2,39.39,39.39,0,0,0-1.27,5.22c-.18,1-.33,2.07-.47,3.12,0-.49,0-.92,0-1-.22-1.7-1.65-4.86-3.54-5.21a2.28,2.28,0,0,0-2.62,2.14,4.73,4.73,0,0,0,1.83,3.56,14.77,14.77,0,0,0,4.18,1.93c-.05.4-.11.8-.16,1.21-.23,1.92-.45,3.85-.72,5.73-.1.67-.22,1.31-.34,2,0-.44,0-.8,0-.86-.22-1.7-1.65-4.86-3.54-5.21a2.28,2.28,0,0,0-2.62,2.14,4.75,4.75,0,0,0,1.83,3.56,14.33,14.33,0,0,0,4.05,1.89c-.14.66-.28,1.33-.44,2-.12.43-.21.86-.36,1.28s-.27.85-.41,1.27c-.29.79-.58,1.61-.88,2.38-.21.53-.41,1-.62,1.55.11-.66.28-1.95.29-2.06a8.87,8.87,0,0,0-1.19-4.3,2.07,2.07,0,0,0,0-.5,2.27,2.27,0,0,0-2.78-1.93c-1.86.49-3,3.75-3.12,5.47,0,.1.06,1.2.11,1.9-.09-.41-.18-.8-.28-1.22-.2-.82-.41-1.63-.65-2.51-.12-.42-.25-.84-.38-1.27s-.3-.86-.45-1.3c-.37-1-.79-2-1.23-3a14.91,14.91,0,0,0,4.28-1.6,4.77,4.77,0,0,0,2.09-3.42,2.28,2.28,0,0,0-2.46-2.33c-1.91.21-3.57,3.25-3.92,4.94,0,.1-.13,1.33-.18,2-.27-.59-.54-1.19-.84-1.79-.85-1.72-1.77-3.43-2.68-5.15-.28-.52-.55-1.05-.82-1.57a15.78,15.78,0,0,0,4.44-1.65,4.74,4.74,0,0,0,2.09-3.41,2.28,2.28,0,0,0-2.46-2.33c-1.91.21-3.57,3.25-3.92,4.93,0,.13-.18,1.91-.2,2.36-.6-1.16-1.19-2.32-1.73-3.49a39.49,39.49,0,0,1-1.87-4.84,16.24,16.24,0,0,0,4.47-1.65,4.75,4.75,0,0,0,2.08-3.41,2.27,2.27,0,0,0-2.45-2.33c-1.92.21-3.57,3.25-3.92,4.93,0,.13-.2,2-.21,2.39,0-.09-.07-.19-.09-.29a28.52,28.52,0,0,1-1-5.11c-.1-.95-.15-1.87-.18-2.77a15.23,15.23,0,0,0,4.51-1.13,4.77,4.77,0,0,0,2.45-3.17,2.27,2.27,0,0,0-2.19-2.58c-1.92,0-3.9,2.84-4.43,4.47,0,.09-.22,1-.35,1.71,0-.41,0-.82,0-1.21,0-1.45.09-2.78.19-4,.05-.67.12-1.27.18-1.84a15.24,15.24,0,0,0,3.47-3.07,4.79,4.79,0,0,0,.71-3.94,2.27,2.27,0,0,0-3.13-1.28c-1.71.88-2.16,4.32-1.87,6,0,.14.67,2.39.7,2.37l0,0c-.08.54-.15,1.12-.22,1.76-.12,1.18-.24,2.51-.27,4a40,40,0,0,0,.11,4.71,30,30,0,0,0,.87,5.2.14.14,0,0,1,0,.06c-.3-.48-1.19-1.78-1.27-1.87-1.12-1.3-4-3.14-5.82-2.39a2.27,2.27,0,0,0-1,3.23A4.73,4.73,0,0,0,358.37,416.64Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.32,407.61s.62-2.24.64-2.39c.23-1.7-.31-5.12-2-6a2.27,2.27,0,0,0-3.09,1.37,4.73,4.73,0,0,0,.82,3.92C388.46,405.81,391.32,407.61,391.32,407.61Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.34,423a10.4,10.4,0,0,0,3,.33s-.46-1.4-.5-1.49c-.47-1-1.95-2.6-3.16-2.44a1.44,1.44,0,0,0-1.16,1.81A3,3,0,0,0,414.34,423Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.08,429.18a9.89,9.89,0,0,0,3-.47,26.9,26.9,0,0,0,1.16,3.21c.27.61.55,1.21.84,1.82-.17-.26-.33-.49-.36-.52-.71-.82-2.57-2-3.69-1.52a1.44,1.44,0,0,0-.64,2.05,3,3,0,0,0,2.21,1.25,9.6,9.6,0,0,0,2.89-.44c.11.23.22.46.34.69.55,1.1,1.11,2.2,1.62,3.29.18.38.35.77.51,1.16-.15-.23-.28-.42-.31-.45-.71-.82-2.57-2-3.69-1.52a1.44,1.44,0,0,0-.64,2A3,3,0,0,0,420.5,441a9.39,9.39,0,0,0,2.81-.42c.16.4.32.8.45,1.19s.19.53.26.81.15.54.23.81c.12.52.25,1.06.36,1.57.08.35.15.69.22,1l-.57-1.19c-.58-.92-2.25-2.36-3.43-2.06a1.44,1.44,0,0,0-.94,1.93,3,3,0,0,0,2,1.57,10,10,0,0,0,3,0c.11.56.22,1.12.31,1.64.2,1.15.35,2.19.47,3.06h.8c-.14-.9-.32-2-.56-3.19-.12-.58-.25-1.19-.39-1.82a16.76,16.76,0,0,0,1.67-.78,10.51,10.51,0,0,0,2.43,1.56c-.22.54-.43,1.06-.65,1.54-.44,1-.86,1.92-1.23,2.69h.86c.32-.71.67-1.51,1-2.41.22-.54.45-1.12.68-1.72a10.45,10.45,0,0,0,3,.23,3,3,0,0,0,2.11-1.42,1.44,1.44,0,0,0-.8-2c-1.15-.39-2.92.92-3.56,1.8,0,.05-.39.66-.61,1.05.09-.25.18-.49.28-.74.18-.51.35-1,.53-1.56.08-.27.16-.53.25-.81s.14-.56.21-.84c.16-.66.29-1.34.4-2a9.69,9.69,0,0,0,2.83.65,3,3,0,0,0,2.3-1.08,1.43,1.43,0,0,0-.49-2.09c-1.08-.56-3,.47-3.8,1.24,0,.05-.54.66-.8,1,.07-.41.13-.82.18-1.24.15-1.21.27-2.44.39-3.66,0-.38.08-.75.11-1.13a10.2,10.2,0,0,0,2.93.69,3,3,0,0,0,2.3-1.08,1.44,1.44,0,0,0-.49-2.09c-1.08-.56-3,.47-3.79,1.24-.06.06-.77.94-.94,1.17.09-.82.18-1.64.31-2.44a24.94,24.94,0,0,1,.7-3.23,10.24,10.24,0,0,0,2.94.7,3,3,0,0,0,2.3-1.08,1.44,1.44,0,0,0-.48-2.09c-1.09-.56-3,.47-3.8,1.24-.06.06-.82,1-.95,1.19,0-.06,0-.13,0-.19a19.52,19.52,0,0,1,1.28-3.05c.28-.54.57-1,.87-1.52a10,10,0,0,0,2.79,1,3,3,0,0,0,2.4-.82,1.46,1.46,0,0,0-.25-2.14c-1-.67-3.06.14-3.92.82l-.78.78.41-.65c.51-.76,1-1.44,1.49-2,.26-.33.51-.63.74-.91a9.51,9.51,0,0,0,2.91-.41,3,3,0,0,0,1.76-1.83,1.45,1.45,0,0,0-1.21-1.78c-1.21-.13-2.65,1.53-3.1,2.53,0,.08-.48,1.5-.46,1.5h0l-.73.85c-.48.58-1,1.25-1.54,2a26.39,26.39,0,0,0-1.59,2.53,19.92,19.92,0,0,0-1.36,3.06.06.06,0,0,1,0,0c0-.36,0-1.36,0-1.43-.14-1.09-1-3.09-2.24-3.31a1.45,1.45,0,0,0-1.67,1.36,3.07,3.07,0,0,0,1.16,2.26,9.89,9.89,0,0,0,2.74,1.24,25.13,25.13,0,0,0-.8,3.32c-.12.65-.22,1.31-.31,2,0-.31,0-.59,0-.63-.14-1.08-1.05-3.08-2.25-3.31a1.45,1.45,0,0,0-1.66,1.36,3,3,0,0,0,1.16,2.26,9.59,9.59,0,0,0,2.65,1.23c0,.25-.07.5-.1.76-.14,1.22-.28,2.45-.46,3.64-.06.42-.14.83-.21,1.25,0-.28,0-.51,0-.54-.14-1.08-1-3.09-2.24-3.31a1.45,1.45,0,0,0-1.67,1.36,3.05,3.05,0,0,0,1.16,2.26,9.19,9.19,0,0,0,2.58,1.19c-.09.43-.18.85-.28,1.25s-.14.54-.23.81-.17.54-.26.81c-.18.5-.37,1-.56,1.51s-.26.66-.39,1c.06-.42.18-1.24.18-1.31a5.66,5.66,0,0,0-.75-2.72c0-.11,0-.22,0-.32a1.45,1.45,0,0,0-1.77-1.23c-1.18.32-1.93,2.38-2,3.47,0,.07,0,.77.07,1.21-.06-.26-.11-.51-.18-.77-.12-.52-.26-1-.41-1.6l-.24-.8c-.08-.27-.19-.55-.29-.83-.23-.63-.5-1.27-.78-1.9a9.42,9.42,0,0,0,2.72-1,3,3,0,0,0,1.32-2.17A1.44,1.44,0,0,0,426,435c-1.22.14-2.27,2.07-2.49,3.14,0,.06-.09.84-.12,1.28-.17-.38-.34-.76-.53-1.14-.54-1.09-1.12-2.18-1.7-3.27-.18-.33-.35-.67-.52-1a10.09,10.09,0,0,0,2.82-1,3,3,0,0,0,1.32-2.17,1.45,1.45,0,0,0-1.56-1.48c-1.21.14-2.26,2.07-2.48,3.13,0,.08-.12,1.21-.13,1.5-.39-.74-.76-1.47-1.1-2.21a25.35,25.35,0,0,1-1.19-3.08,10,10,0,0,0,2.84-1,3,3,0,0,0,1.32-2.17,1.45,1.45,0,0,0-1.56-1.48c-1.21.13-2.26,2.07-2.48,3.13,0,.09-.13,1.3-.13,1.52l-.07-.18a18.69,18.69,0,0,1-.61-3.25c-.07-.61-.1-1.19-.12-1.76a9.46,9.46,0,0,0,2.86-.72,3,3,0,0,0,1.56-2,1.45,1.45,0,0,0-1.39-1.64c-1.22,0-2.48,1.8-2.81,2.83,0,.06-.15.65-.23,1.09,0-.26,0-.52,0-.77,0-.92.06-1.77.12-2.51,0-.43.08-.81.12-1.17a9.83,9.83,0,0,0,2.2-1.95,3,3,0,0,0,.45-2.5,1.45,1.45,0,0,0-2-.82c-1.08.56-1.37,2.75-1.19,3.82,0,.09.43,1.52.45,1.51l0,0c-.05.34-.1.71-.14,1.12-.07.75-.15,1.59-.17,2.52a23.53,23.53,0,0,0,.07,3,19.1,19.1,0,0,0,.55,3.3.06.06,0,0,1,0,0c-.19-.3-.75-1.13-.8-1.19-.72-.82-2.58-2-3.7-1.52a1.44,1.44,0,0,0-.64,2.05A3,3,0,0,0,415.08,429.18Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,423.45s.39-1.42.4-1.52c.15-1.08-.19-3.25-1.29-3.78a1.44,1.44,0,0,0-2,.87,3,3,0,0,0,.52,2.48A10.21,10.21,0,0,0,436,423.45Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.45,421.47a10.35,10.35,0,0,0,3,.33s-.46-1.4-.5-1.48c-.47-1-2-2.61-3.17-2.44a1.44,1.44,0,0,0-1.16,1.8A3,3,0,0,0,73.45,421.47Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.19,427.67a10.36,10.36,0,0,0,3-.46,25.13,25.13,0,0,0,1.16,3.2c.26.61.54,1.22.83,1.82-.17-.26-.33-.48-.35-.51-.72-.83-2.58-2-3.7-1.52a1.44,1.44,0,0,0-.64,2.05,3,3,0,0,0,2.21,1.24,9.6,9.6,0,0,0,2.89-.44c.12.23.23.46.34.69.56,1.1,1.11,2.2,1.63,3.29.18.39.34.77.51,1.16l-.31-.44c-.72-.83-2.58-2-3.7-1.52a1.44,1.44,0,0,0-.64,2,3,3,0,0,0,2.21,1.24,9.08,9.08,0,0,0,2.81-.42c.16.4.32.8.45,1.19s.19.53.26.81.15.54.23.81c.12.52.26,1.06.37,1.57.07.36.14.7.21,1-.17-.39-.53-1.13-.57-1.19-.58-.93-2.24-2.37-3.42-2.07a1.44,1.44,0,0,0-1,1.93,3,3,0,0,0,2,1.57,10,10,0,0,0,3,0c.11.57.22,1.12.31,1.64.2,1.16.36,2.19.47,3.07h.8c-.14-.91-.32-2-.56-3.2-.11-.58-.24-1.19-.39-1.82a13.14,13.14,0,0,0,1.67-.78,11.07,11.07,0,0,0,2.43,1.57c-.21.53-.43,1-.64,1.54-.45,1-.87,1.92-1.24,2.69h.87c.32-.71.67-1.52,1-2.41.23-.54.45-1.13.68-1.73a9.79,9.79,0,0,0,3,.23,3,3,0,0,0,2.11-1.41,1.45,1.45,0,0,0-.79-2c-1.16-.39-2.92.93-3.57,1.8,0,.06-.39.66-.61,1.05.1-.25.19-.49.28-.74.18-.5.35-1,.54-1.56l.24-.8c.09-.27.14-.57.22-.85.15-.66.28-1.34.39-2a9.45,9.45,0,0,0,2.83.65,3,3,0,0,0,2.3-1.08,1.44,1.44,0,0,0-.48-2.09c-1.09-.56-3,.47-3.8,1.24,0,.05-.54.66-.81,1,.07-.41.14-.82.19-1.24.15-1.21.26-2.44.38-3.66l.12-1.12a10.09,10.09,0,0,0,2.92.68,3,3,0,0,0,2.3-1.07,1.45,1.45,0,0,0-.48-2.1c-1.09-.56-3,.47-3.8,1.24-.06.06-.77.94-.93,1.18.08-.83.18-1.65.3-2.45A25.16,25.16,0,0,1,93,427a10.58,10.58,0,0,0,2.94.69,3,3,0,0,0,2.3-1.08,1.44,1.44,0,0,0-.49-2.09c-1.08-.56-3,.47-3.8,1.24-.06.06-.82,1-.94,1.19,0-.06,0-.12.05-.18a17.88,17.88,0,0,1,1.27-3.05q.42-.81.87-1.53a10,10,0,0,0,2.79,1,3,3,0,0,0,2.4-.82,1.44,1.44,0,0,0-.25-2.13c-1-.68-3.06.13-3.91.81l-.79.78c.14-.21.28-.44.42-.64.51-.77,1-1.44,1.48-2,.27-.33.51-.63.75-.9a9.54,9.54,0,0,0,2.9-.42A3,3,0,0,0,102.7,416a1.44,1.44,0,0,0-1.21-1.78c-1.21-.13-2.65,1.53-3.09,2.53,0,.09-.49,1.5-.46,1.5h0l-.73.85c-.47.59-1,1.25-1.53,2a25.68,25.68,0,0,0-1.59,2.53,18.53,18.53,0,0,0-1.36,3.06.08.08,0,0,0,0,0c0-.36,0-1.36,0-1.43-.14-1.08-1-3.09-2.25-3.31a1.44,1.44,0,0,0-1.66,1.36A3,3,0,0,0,90,425.58a10.14,10.14,0,0,0,2.73,1.25,25,25,0,0,0-.8,3.31c-.12.65-.21,1.31-.3,2,0-.31,0-.59,0-.63-.14-1.08-1-3.08-2.24-3.3a1.45,1.45,0,0,0-1.67,1.36,3,3,0,0,0,1.16,2.25A9.73,9.73,0,0,0,91.48,433l-.09.76c-.15,1.23-.29,2.45-.47,3.64-.06.42-.13.84-.21,1.25,0-.27,0-.51,0-.54-.14-1.08-1-3.09-2.25-3.31a1.44,1.44,0,0,0-1.66,1.36A3,3,0,0,0,88,438.45a9.49,9.49,0,0,0,2.57,1.2c-.09.42-.17.84-.28,1.24s-.13.55-.23.82-.17.53-.26.8c-.18.5-.37,1-.56,1.51s-.26.66-.39,1c.07-.41.18-1.24.18-1.31a5.58,5.58,0,0,0-.75-2.72,1.67,1.67,0,0,0,0-.32,1.46,1.46,0,0,0-1.77-1.23c-1.17.32-1.92,2.39-2,3.48,0,.06,0,.76.07,1.2,0-.26-.11-.51-.17-.77-.13-.52-.27-1-.41-1.59-.08-.27-.16-.54-.25-.81s-.19-.55-.28-.82c-.23-.64-.5-1.28-.79-1.91a9.31,9.31,0,0,0,2.72-1A3,3,0,0,0,86.68,435a1.44,1.44,0,0,0-1.56-1.48c-1.21.13-2.27,2.06-2.49,3.13,0,.06-.08.85-.11,1.28-.18-.38-.35-.76-.54-1.14-.54-1.09-1.12-2.18-1.7-3.27-.17-.33-.35-.66-.52-1a9.77,9.77,0,0,0,2.82-1,3,3,0,0,0,1.32-2.17,1.43,1.43,0,0,0-1.56-1.47c-1.21.13-2.26,2.06-2.48,3.13,0,.08-.12,1.2-.13,1.49-.38-.73-.76-1.47-1.1-2.21a27.7,27.7,0,0,1-1.19-3.07,10.28,10.28,0,0,0,2.84-1.05A3,3,0,0,0,81.6,424,1.44,1.44,0,0,0,80,422.5c-1.21.14-2.26,2.07-2.48,3.14,0,.08-.13,1.29-.13,1.51a1.27,1.27,0,0,1-.06-.18,17.68,17.68,0,0,1-.62-3.25c-.07-.6-.1-1.19-.12-1.75a9.82,9.82,0,0,0,2.87-.72,3,3,0,0,0,1.55-2,1.44,1.44,0,0,0-1.39-1.64c-1.22,0-2.47,1.8-2.81,2.84,0,.05-.14.65-.22,1.08,0-.26,0-.52,0-.77,0-.92.06-1.76.12-2.51,0-.43.08-.81.12-1.17a9.62,9.62,0,0,0,2.2-1.95,3,3,0,0,0,.45-2.5,1.43,1.43,0,0,0-2-.81c-1.09.56-1.37,2.74-1.19,3.81,0,.1.42,1.52.44,1.51l0,0c-.05.35-.09.72-.14,1.12-.07.75-.15,1.59-.17,2.52a27.87,27.87,0,0,0,.07,3,19,19,0,0,0,.56,3.3s0,0,0,0c-.19-.3-.76-1.13-.81-1.18-.71-.83-2.57-2-3.7-1.52a1.45,1.45,0,0,0-.64,2.05A3.05,3.05,0,0,0,74.19,427.67Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,421.94s.39-1.42.41-1.51c.15-1.08-.2-3.26-1.3-3.79a1.44,1.44,0,0,0-2,.87,3.06,3.06,0,0,0,.52,2.49A10.37,10.37,0,0,0,95.1,421.94Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#828282"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.17,439.29a1.17,1.17,0,0,0-1.25.44c-1.41,1.92-5.61,7.39-8.92,9.41-4,2.46-10.53,4.48-11,6.5a2.89,2.89,0,0,0,2.68,3.58c1.57,0,7.62,1.12,15.47.45s11.65-2.91,16.35-2,8.52,1.13,10.31-2c1.46-2.56.84-11.66.56-14.94a1.19,1.19,0,0,0-1.29-1.09C315.12,439.94,302.11,440.87,296.17,439.29Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.53,457.65c4.71.9,8.52,1.13,10.31-2a5,5,0,0,0,.44-1.17,1.19,1.19,0,0,0-1.5-1.42,49.35,49.35,0,0,1-12.61,1.47c-5.82,0-6.72.67-17.25,2.46a39.59,39.59,0,0,1-13.88.09,2.86,2.86,0,0,0,2.67,2.15c1.57,0,7.62,1.12,15.47.45S304.83,456.76,309.53,457.65Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,439.76a1.19,1.19,0,0,0-1.39.62c-1.25,2.48-5,9.55-8.09,12.12-3.81,3.14-10.75,4.71-11,7.84s3.14,3.59,4.71,3.59,11.88,1.57,17.7,0,9.64-.9,12.55-1.57,8.74-.67,10.08-2.69c1.11-1.66.08-10-.31-12.92a1.18,1.18,0,0,0-1.1-1c-2.6-.18-9.83-.81-13.82-2.63A67.92,67.92,0,0,0,321.25,439.76Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.83,459.67c.46-.68.55-2.49.48-4.59a21.32,21.32,0,0,0-4.32,1.17c-7.52,2.84-16.22,5.69-27.25,5.52-7.38-.11-11.75-1.19-13.85-1.9a3.56,3.56,0,0,0-.1.47c-.22,3.14,3.14,3.59,4.71,3.59s11.88,1.57,17.7,0,9.64-.9,12.55-1.57S344.49,461.69,345.83,459.67Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,290.62s-1.57,52.21,1.12,67.45,5.6,51,6.5,55.22c.71,3.36,2.25,10.5,2.87,13.35a1.19,1.19,0,0,1-.84,1.4,3.07,3.07,0,0,0-2.26,3.17c0,2.81.47,7.49.63,9a1.19,1.19,0,0,0,.49.85c.79.57,2.89,1.79,8.3,3.64a23.44,23.44,0,0,0,13.92.51,1.09,1.09,0,0,0,.34-.17c.68-.49,3.62-2.53,5-2.13,1.56.44,7.39,3.81,13.89,5.15s10.75,1.34,11,.22a47.27,47.27,0,0,0,1.12-12.77c-.45-5.82-.67-4.48-1.12-9.41s2-37.74.22-50.51-4.25-14.79-4.7-23.76S344,289.5,344,289.5s-22.18,3.81-30.92,1.79-12.55-6.72-18.38-7.39S284.66,290.62,284.66,290.62Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,173.68s-9,1.88-11.29,5.84-6.22,23-6.22,23l-10,21.65,13.36,17.51,4.52-5.08,2.45,32.19-3,22.4,6.78,4.52,4.71-8.47,1.88,9.41A56.57,56.57,0,0,0,322.35,300c15.63-2.07,25.42-9.6,25.42-9.6s.37-25.6.56-26.17,1.88-28.8,1.88-28.8-7-50.27-8.09-55-.38-5.46-4.14-7-20-7-20-7-12-.75-15,.2S291.29,173.68,291.29,173.68Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.74,228.57a6.52,6.52,0,0,1,2.21-2.71c1.36-.73,1.11-6.27,6.15-4.79s12.43,15.74,12.67,18.08-1.35,3.56-2.09,4.55a43.88,43.88,0,0,1-4.06,5.78c-2,2.09-2.46,4.3-4.92,3.07s-4.55-6.88-7.25-14S258.74,228.57,258.74,228.57Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,178.62s-1.28,7.68-.28,7.54,4.83-3,5-3.84S285.27,178.62,285.27,178.62Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.11,172.64s-5.27,5.27-4.84,6,8.25,8.53,8.25,8.53,1.43-7.11.86-10.24S290.11,172.64,290.11,172.64Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,125.55s-4.27,9.81-4,11.81,1.42,5.69,1,6.68-5.69,5.13-5.55,6.12,3.13,4,3.13,4,2.28,12.66,3.27,14.51,8-.29,8-.29,4.7,5.27,4.84,6.55,3.56,18.07,4.13,16.36,6.68-14.09,6.68-14.09S313.3,165.1,313,164.39s-5.54-8.54-5.54-9.68,8.39-13.94,8.11-18.63-3.7-13.09-9-16.08-12.66-5.84-20.49-3.84S277.87,121.28,279.58,125.55Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.41 156.02 278.25 162.56 280.17 152.77 273.41 156.02",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,164c.85-1.56,1.7-22.9,2.41-24s3.85-.43,4.7,3-2.56,7.82-2.56,8.25A9.62,9.62,0,0,0,303.2,155a9.12,9.12,0,0,0,4.31-.08,1.07,1.07,0,0,1,0-.21c0-.94,5.79-10,7.59-15.66a105.91,105.91,0,0,0-12-8.38c-7.55-4.7-11.24-3-11.24-3s-5.41,4.7-4.27,6.4,5.55,5.27,5.55,5.27-1.28,14.51-1.85,15.36a5.28,5.28,0,0,1-1.57,1.43s-2.56-5-4.55-5-11,3-11,3,2.28,12.66,3.27,14.51,8-.29,8-.29S293.52,165.53,294.38,164Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,120c-5.26-3-12.66-5.84-20.49-3.84s-8.25,5.12-6.54,9.39a15.52,15.52,0,0,0,5.69,2.27,43.11,43.11,0,0,1,19.49,8l9,6.55c1.11-2.48,1.89-4.78,1.8-6.26C315.29,131.38,311.88,123,306.61,120Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,143.9c0,.87-.38,1.57-.85,1.57s-.86-.7-.86-1.57.39-1.56.86-1.56S281,143,281,143.9Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,140.06s1.85-2.85,5,.28",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.3,156.71s5.12.14,7-3.28",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,177.76l4.41,8.54s8.68-8.11,11.24-11.1a105.25,105.25,0,0,0,6.26-8.68s-4.26-4-5.54-4.41-1.57.57-2.28,1.43S296.08,177.76,296.08,177.76Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.37,248s-6.22,33.32-6.59,35.2-.57,3.2-1.32,3.58-4.9,1.7-5.46,2.82-3.39,9.61-4.33,11.3,1.32,2.07,2.26,1.69a6,6,0,0,0,1.88-1.5s-.94,7.53-.19,7.72a4.43,4.43,0,0,0,3.2-.76c1.13-.75,1.32-1.31,1.89-1.69s3.2-.57,4.33-1.32,2.44-2.07,3-2.26a2.76,2.76,0,0,0,2.26-2.63c.37-2.26,1.13-12.24,1.5-13.18s15.44-35.2,15.44-35.2Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,178.2s-10.54,12.42-9.41,20.52,12.8,29.74,12.8,29.74-1.89,5.09-.94,6.4a25.52,25.52,0,0,1,2.07,4.52l18.82,4.71s2.64-1.32,2.26-7A42.9,42.9,0,0,0,360,225.64c-.37-.94-10.73-39-14.12-44.81s-6.21-6-7-6",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,237.31s.37-.19-.94,2.07-1.7,9.79-1.13,10.54,17.32,5.65,18.82,5.09,2.45-4.52,3.58-8.48,2.26-4.14-1.88-6.58S343.62,236.93,342.31,237.31Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.9,323.47c2,15.3,5.38,40.58,6.3,44.91a230.15,230.15,0,0,0,7.62,24.2c1,2.22,2.58,35.82,2.87,41.7a1.2,1.2,0,0,1-.79,1.18,1.92,1.92,0,0,0-1.4,1.8c0,1.8-.23,5.61-.23,5.61",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,311.69s.38,2.95,1,7.52",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,216.76s6.51,5.17,11.07,7.26,7.13,2.58,12.67,8.12,9.22,15.49,7.87,18-3.45,3.2-7.38,1.6-9.23-.49-15.38-8.61-18.08-19.55-18.08-19.55Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.42,215.05c1.33,6.18,2.68,14.5,2.27,21.51",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.17,206.06s.46,1.53,1.09,4",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.18,277.08c-.25,2.5-.45,4.08-.45,4.08",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.18,222.79c.14,2.1.32,4.05.55,5.72,1.43,10.3-.57,21.46-.57,31.47,0,4.2-.25,8.59-.55,12.29",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.87,197s-.27,9.9,0,19.46",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.13,437.8s11.67,8.69,15.27,10.39,10.39,3,10.18,5.72-6.15,4.25-15.48,4-13.36-1.06-19.72-1.69-11.24,2.54-14.42,0,.42-17.18.42-17.18Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,454.13a58.24,58.24,0,0,1-13-1.89c.09,1.84.46,3.34,1.29,4,3.18,2.54,8.06-.64,14.42,0s10.39,1.48,19.72,1.69,15.27-1.27,15.48-4A103.84,103.84,0,0,1,199.46,455C189.5,455,185.26,454.34,177.62,454.13Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.14,439.92s3.18,4,10.82,9.33,12.72,5.51,13.35,8.06,0,5.09-2.33,5.51-28.62-.21-36.26-.85-12.09-.42-12.72-2.75-.21-9.55-.21-9.55a114.73,114.73,0,0,0,11.45-7C160.45,437.8,169.14,439.92,169.14,439.92Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,460.28c-7.59,0-34-1.77-42.62-2.36a8.62,8.62,0,0,0,.21,1.3c.63,2.33,5.09,2.12,12.72,2.75s33.93,1.28,36.26.85a3.12,3.12,0,0,0,2.51-3A90,90,0,0,1,184.41,460.28Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,289.36a255,255,0,0,0,2.12,40.93c3,21.42,2.12,40.08,2.33,43.68s-3.6,18.24-4.24,33.93,1.27,40.08,1.27,41.35.64,3.82,1.91,3.82,12.73-5.94,12.73-5.94l14.2-4.88a86.87,86.87,0,0,0,11.24-.85c5.73-.84,9.33-2.75,9.54-3.6a8,8,0,0,0-.84-5.51c-1.28-2.12-3,0-1.28-5.94s10-44.53,9.55-59.59,6.57-52.8,6.57-60.86.76-17.17.76-17.17l-.76-6.37s-16.54,7.85-34.14,7.21a104.26,104.26,0,0,1-30.75-5.72Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.07,428.44a76.27,76.27,0,0,0,.77,8.3l1.48,4.88",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,310.14l-7.42,5.94s-.64,28.42-4.67,43.68-7,42.63-7,56.83c0,1.32,0,2.57,0,3.75",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.56,164.34s-17.57,9.07-21.73,13-7.37,16.7-7.18,31.62a288,288,0,0,0,2.84,32.69l1.7,49.32s21.54,6.61,37,6.23a77.94,77.94,0,0,0,27-5.48s2.65-1.13,2.65-3-.57-21.16.18-28.34-1.51-54.11-4.91-65.63a95.54,95.54,0,0,0-7-17.95c-1.32-3,.38-2.46-8.88-7.94S168.23,162.07,162.56,164.34Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.58,179.26s.19-1.7,1.32-1.51,7.37,6.24,6.43,4-4.73-9.83-7.56-12.09-3.4-1.52-3.4.19S189.58,179.26,189.58,179.26Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.49,160.18,188.07,170s2.83,16.25.75,16.25-3.59-7.18-4.34-8.12-17.95-20-17.95-20l5.86-16.63s4.34-1.51,7.37,3.4S194.49,160.18,194.49,160.18Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.37 145.67 176.92 155.69 181.08 149.82 167.88 142.24 168.37 145.67",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,155.64s14.93,17,16.07,18.33,3.59,3.21,2.64,4.35-8.88,9.45-8.88,9.45-8.31-6.05-12.28-13.42-4.35-8.5-4.35-8.5S162.75,157,167.28,155.64Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.18,123.12s2.87,0,2.51-4.3-4.3-8.25-4.84-7.35,1.26,3.76-1.07,2.33-3.59-5-6.09-4.66-2.87,2.87-3.41,3.4-10.39-2-17.56.18-11.11,10-10.4,13.27,4.3,14.33,6.45,17.74,2.51,4.3,5.2,5,5.38,2.15,7.35-3.23.36-5.73,3.4-7.53,7-2.33,6.64-6.81.53-5,2-5.55S201.29,124.73,202.18,123.12Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.18,123.12s5.2,13.26,4.31,14.52a26.73,26.73,0,0,1-2.33,2.68s4.48,7.53,2.86,9.32a16.49,16.49,0,0,1-3.4,2.87s-2,10.75-4.12,12-3.05,2.69-7.89,0-10.57-5-12.72-7.17-3.23-7.89-3.23-7.89-4.84-1.25-6.27-5.73.89-7.89,3-7.35,3.41,3.41,4.13,4.84,2.86,1.79,3.22.72-2.33-4.3-1.07-6.1,6.09-2.15,7.17-4.12-2.33-2.87-2.33-2.87,2.33-.89,1.61-1.61-4.66-.36-3.76-2.51,6.45-3.22,11.29-2.51S202.18,123.12,202.18,123.12Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.14,140.86c0,1-.52,1.79-1.17,1.79s-1.16-.8-1.16-1.79.52-1.79,1.16-1.79S199.14,139.87,199.14,140.86Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,136.56a6.15,6.15,0,0,1,6.63,0",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,153.41a6,6,0,0,1-5-4.3",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,181.49s-9.13,15.45-8,27.5,42.68,54.71,44,53.37,66.64-47.17,66.64-47.17,5.29-2.38,5.75-4.33,0-2.75,0-3.9.68-2.52.45-4-1.14-1.83-1.95-2.75-.45-1.38-.57-3.1-1.26-1.72-2.86-2.63-2.53-1.49-3.21-1.84.45-.46-1.61-.11a19,19,0,0,1-7.22.23c-2.52-.58-3.21,2.06-3.44,3.44a11.39,11.39,0,0,0-.23,3.21c.11.8.23,8.94-.23,9.74s-7.11,7.45-19,12.27-27.05,11.46-27.05,11.46-6.77-11.35-8.83-16.05-13.07-21-13.41-21.27",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,210.86c.45-2,0-2.75,0-3.9s.68-2.52.45-4-1.14-1.83-1.95-2.75-.45-1.38-.57-3.1-1.26-1.72-2.86-2.63-2.53-1.49-3.21-1.84.45-.46-1.61-.11a19,19,0,0,1-7.22.23c-2.52-.58-3.21,2.06-3.44,3.44a11.39,11.39,0,0,0-.23,3.21c.11.8.23,8.94-.23,9.74s-7.11,7.45-19,12.27-27.05,11.46-27.05,11.46-1.71-2.85-3.66-6.29l-3.34,1.59c-10.23,4.93-14.53,14.89-15.63,17.91,8.86,9.54,16.63,16.85,17.19,16.28C179,261,244.3,215.19,244.3,215.19S249.59,212.81,250.05,210.86Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.54,190.41s-2.66.2-3,1.19.21,5.25.94,5.51,3,.12,3.38-.91a14.43,14.43,0,0,0,.16-4.16A1.77,1.77,0,0,0,238.54,190.41Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,196.41s-5-.81-6,0-.77,2.27-.85,2.58-2.43,1.77-2.58,2.59.23,2.21.05,2.52-1.33,1.5-1.36,2.71a12.85,12.85,0,0,0,.71,3.3s-.2,1.73-.17,2.33.71,1.58,1.32,1.65,4.25.15,4.82-.5l.57-.64s2.51-.35,3.06-1.29.57-.54.55-1,1.46-.89,1.82-1.72a4.73,4.73,0,0,0,.29-1.84s2.14-1.44,2.08-2.45S235,198.41,232.93,196.41Z",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,199.4s2-.93,2.84.13,5.41,7.57,5.41,7.57",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.76,203.47s.59-.23,1.66.71,6.42,5.79,6.42,5.79",
    transform: "translate(-12 -12.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.67,
    y1: 196.55,
    x2: 217.47,
    y2: 200.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.8,
    y1: 177.23,
    x2: 202.03,
    y2: 181.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.37,
    y1: 159.8,
    x2: 222.37,
    y2: 165.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.14,
    y1: 172,
    x2: 244.75,
    y2: 178.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.17,
    y1: 170.55,
    x2: 212.78,
    y2: 174.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.03,
    y1: 169.39,
    x2: 234.29,
    y2: 172.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3fd2ecc28218dee5941ae6f5fb8cf87f.svg";
export { ForwardRef as ReactComponent };